const initialState = {
  typeAlert: "",
  textAlert: "",
  status: false,
  flagExpire: false,
};

export const actionTypes = {
  success: "[success] Action",
  error: "[error] Action",
  info: "[info] Action",
  warning: "[warning] Action",
  close: "[close] Action",
  flagExpire: "[flagExpire] Action",
};

export function reducer_notificationAlert(
  state = initialState,
  { type, textAlert, payload }
) {
  switch (type) {
    case actionTypes.success:
      return {
        ...state,
        typeAlert: "success",
        textAlert: textAlert ? textAlert : "با موفقیت انجام شد.",
        status: true,
      };
    case actionTypes.error:
      return {
        ...state,
        typeAlert: "error",
        textAlert: textAlert ? textAlert : "متاسفانه انجام نشد.",
        status: true,
      };
    case actionTypes.info:
      return {
        ...state,
        typeAlert: "info",
        textAlert: textAlert ? textAlert : "مقادیر ورودی اشتباه می باشد.",
        status: true,
      };
    case actionTypes.warning:
      return {
        ...state,
        typeAlert: "warning",
        textAlert: textAlert ? textAlert : "اطلاعات ورودی دریافت نشد.",
        status: true,
      };
    case actionTypes.flagExpire:
      return {
        ...state,
        flagExpire: payload,
      };
    case actionTypes.close:
      return initialState;

    default:
      return state;
  }
}

// /////////////////typeAlert
// success
// info
// warning
// error
